export const MIME_TYPES = {
  GIF: 'image/gif',
  JPEG: 'image/jpeg',
  PDF: 'application/pdf',
  PNG: 'image/png',
  WEBP: 'image/webp',
} as const;

export type MimeType = typeof MIME_TYPES[keyof typeof MIME_TYPES];